import { APP_ENV_CONFIG } from './config-env';
import { userPolicyFeatureCode } from './userGroupPolicy';

export const [
  NEWLINE,
  RECONTRACT,
  RRP_EQUIPMENT,
  RRP_ACCESSORY,
  NUMBER_SHARE,
  RESERVE_NUMBER,
  CATALOGUE,
  TERMINATE_NUMBER,
  CEASE_ADDONS,
  CHANGE_PLAN,
  REPLACE_SIM,
  BUY_ADD_ONS,
  CHECK_ELIGIBILITY,
  ELIGIBLIE_NUMBERS_DETAILS,
  ACTIVATE_SIM,
  SUSPEND_LINE,
  UNSUSPEND_LINE,
  REPORT_LOST,
  NUMBER_PORT,
  SELECT_CEASE_ADDONS,
  TRANSACTION_ORDER_DETAIL,
  USER_GUIDE,
  TRANSACTIONHISTORY,
  CHANGE_MOBILE_NUMBER,
  MOBILE_SHARE,
  TRANSFER_MOBILE_LINE,
  TRANSFER_LINE_APPLICATION_DETAIL,
  TRANSFER_LINE_SERVICE_DETAIL,
  PERSONAL_SELECTION_ERROR_PAGE,
  TRANSFER_LINE_REQUEST_SUBMIT_PAGE,
  SER_ROADSHOW,
  SELECT_REPORT_LOST,
  STAFF_CHECK_ELIGIBILITY,
  CU,
  CHANGE_BILLING_ADDRESS,
  GET_ESIM_ACTIVATION_CODE,
  REFIT_LINE,
  BUY_E_FORM,
  EARLY_RECONTRACT
] = [
    'NEWLINE',
    'RECONTRACT',
    'RRP_EQUIPMENT',
    'RRP_ACCESSORY',
    'NUMBER_SHARE',
    'RESERVE_NUMBER',
    'CATALOGUE',
    'TERMINATE_NUMBER',
    'CEASE_ADDONS',
    'CHANGE_PLAN',
    'REPLACE_SIM',
    'BUY_ADD_ONS',
    'CHECK_ELIGIBILITY',
    'ELIGIBLIE_NUMBERS_DETAILS',
    'ACTIVATE_SIM',
    'SUSPEND_LINE',
    'UNSUSPEND_LINE',
    "REPORT_LOST",
    'NUMBER_PORT',
    "SELECT_CEASE_ADDONS",
    "TRANSACTION_ORDER_DETAIL",
    'USER_GUIDE',
    "TRANSACTIONHISTORY",
    "CHANGE_MOBILE_NUMBER",
    'MOBILE_SHARE',
    "TRANSFER_MOBILE_LINE",
    "TRANSFER_LINE_APPLICATION_DETAIL",
    "TRANSFER_LINE_SERVICE_DETAIL",
    "PERSONAL_SELECTION_ERROR_PAGE",
    "TRANSFER_LINE_REQUEST_SUBMIT_PAGE",
    'SER_ROADSHOW',
    "SELECT_REPORT_LOST",
    'STAFF_CHECK_ELIGIBILITY',
    'CU',
    'CHANGE_BILLING_ADDRESS',
    "GET_ESIM_ACTIVATION_CODE",
    "REFIT_LINE",
    "BUY_E_FORM",
    'EARLY_RECONTRACT'
  ];

export const ALL_RRP = [RRP_EQUIPMENT, RRP_ACCESSORY];

export const UPLOAD_FILE_SIZE_10MB = 10 * 1024000;
export const UPLOAD_FILE_SIZE_1MB = 1 * 1024000;
export const UPLOAD_FILE_SIZE_2MB = 2 * 1024000;

export const APP_CONFIG = {
  [NEWLINE]: {
    pageTitle: 'New Line',
    defaultTerm: '24',
    priceKey: 'newlinePrice',
    transactionType: NEWLINE,
    steps: [
      { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
      { pageName: 'EQUIPMENT_PAGE_STEP_DESC', pageKey: 'equipment' },
      { pageName: 'ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsCreateTemplate: [
      { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
      { pageName: 'EQUIPMENT_PAGE_STEP_DESC', pageKey: 'equipment' },
      { pageName: 'ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsEndUserTemplate: [
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    bulk: {
      min: APP_ENV_CONFIG['bulk-min'],
      max: APP_ENV_CONFIG['bulk-max']
    },
    preSelectThreshold: APP_ENV_CONFIG['pre-select-threshold'],
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    addonLimit: APP_ENV_CONFIG['add-on-limit'],
    userPermissionKey: userPolicyFeatureCode['BUY_NEW_LINE']
  },
  [MOBILE_SHARE]: {
    pageTitle: 'New Line',
    defaultTerm: '24',
    priceKey: 'newlinePrice',
    transactionType: MOBILE_SHARE,
    steps: [
      { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
      { pageName: 'EQUIPMENT_PAGE_STEP_DESC', pageKey: 'equipment' },
      { pageName: 'ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsCreateTemplate: [
      { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
      { pageName: 'EQUIPMENT_PAGE_STEP_DESC', pageKey: 'equipment' },
      { pageName: 'ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsEndUserTemplate: [
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    bulk: {
      min: APP_ENV_CONFIG['bulk-min'],
      max: APP_ENV_CONFIG['bulk-max']
    },
    preSelectThreshold: APP_ENV_CONFIG['pre-select-threshold'],
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    addonLimit: APP_ENV_CONFIG['add-on-limit'],
    userPermissionKey: userPolicyFeatureCode['BUY_NEW_LINE']
  },
  [RRP_EQUIPMENT]: {
    pageTitle: 'Mobile Device',
    defaultTerm: '24',
    priceKey: 'devicePrice',
    transactionType: RRP_EQUIPMENT,
    steps: [
      { pageName: 'EQUIPMENT_MOBILE_DEVICE_TITLE', pageKey: 'equipment' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsCreateTemplate: [
      { pageName: 'EQUIPMENT_MOBILE_DEVICE_TITLE', pageKey: 'equipment' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsEndUserTemplate: [
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    bulk: {
      min: APP_ENV_CONFIG['bulk-min'],
      max: APP_ENV_CONFIG['bulk-max']
    },
    preSelectThreshold: APP_ENV_CONFIG['pre-select-threshold'],
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    addonLimit: APP_ENV_CONFIG['add-on-limit'],
    userPermissionKey: userPolicyFeatureCode['BUY_DEVICE_ONLY']
  },
  [RRP_ACCESSORY]: {
    pageTitle: 'Accessories',
    defaultTerm: '24',
    priceKey: 'accessoryPrice',
    transactionType: RRP_ACCESSORY,
    steps: [
      { pageName: 'EQUIPMENT_ACCESSORY_TITLE', pageKey: 'equipment' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsCreateTemplate: [
      { pageName: 'EQUIPMENT_ACCESSORY_TITLE', pageKey: 'equipment' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsEndUserTemplate: [
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    bulk: {
      min: APP_ENV_CONFIG['bulk-min'],
      max: APP_ENV_CONFIG['bulk-max']
    },
    preSelectThreshold: APP_ENV_CONFIG['pre-select-threshold'],
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    addonLimit: APP_ENV_CONFIG['add-on-limit'],
    userPermissionKey: userPolicyFeatureCode['BUY_ACCE_ONLY']
  },
  [BUY_ADD_ONS]: {
    pageTitle: 'Addons',
    defaultTerm: '24',
    priceKey: 'addonsPrice',
    transactionType: BUY_ADD_ONS,
    steps: [
      { pageName: 'CONTRACT_PAGE_STEP_DESC', pageKey: 'contract' },
      { pageName: 'SELECT_ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsCreateTemplate: [
      { pageName: 'SELECT_ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsEndUserTemplate: [
      { pageName: 'CONTRACT_PAGE_STEP_DESC', pageKey: 'contract' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    bulk: {
      min: APP_ENV_CONFIG['bulk-min'],
      max: APP_ENV_CONFIG['bulk-max']
    },
    preSelectThreshold: APP_ENV_CONFIG['pre-select-threshold'],
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    addonLimit: APP_ENV_CONFIG['add-on-limit'],
    userPermissionKey: userPolicyFeatureCode['BUY_MOBI_ADDON']
  },
  [NUMBER_SHARE]: {
    pageTitle: 'NumberShare',
    defaultTerm: '24',
    transactionType: NUMBER_SHARE,
    steps: [
      { pageName: 'NUMBER_SHARE', pageKey: 'numbershare' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    userPermissionKey: userPolicyFeatureCode['BUY_NUM_SHA']
  },
  [RECONTRACT]: {
    pageTitle: 'Recontract',
    defaultTerm: '24',
    bulk: {},
    priceKey: 'reconPrice',
    transactionType: RECONTRACT,
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    steps: [
      { pageName: 'CONTRACT_PAGE_STEP_DESC', pageKey: 'contract' },
      { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
      { pageName: 'EQUIPMENT_PAGE_STEP_DESC', pageKey: 'equipment' },
      { pageName: 'ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsCreateTemplate: [
      { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
      { pageName: 'EQUIPMENT_PAGE_STEP_DESC', pageKey: 'equipment' },
      { pageName: 'ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    stepsEndUserTemplate: [
      { pageName: 'CONTRACT_PAGE_STEP_DESC', pageKey: 'contract' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    addonLimit: APP_ENV_CONFIG['add-on-limit'],
    userPermissionKey: userPolicyFeatureCode['RECONTRACT_LINE']
  },
  [CHANGE_PLAN]: {
    pageTitle: 'Change Plan',
    defaultTerm: '24',
    bulk: {},
    priceKey: 'reconPrice',
    transactionType: CHANGE_PLAN,
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    steps: [
      { pageName: 'CONTRACT_PAGE_STEP_DESC', pageKey: 'changeplan' },
      { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
      { pageName: 'EQUIPMENT_MOBILE_DEVICE_TITLE', pageKey: 'equipment' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    userPermissionKey: userPolicyFeatureCode['CHANGE_MOBI_PLAN']
  },
  [SUSPEND_LINE]: {
    pageTitle: 'Suspend Line',
    defaultTerm: '24',
    transactionType: SUSPEND_LINE,
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    steps: [
      { pageName: 'SUSPEND_LINE_STEP_DESC', pageKey: 'suspendline' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    suspendLineEndDateMaxLimit: 365,
    userPermissionKey: userPolicyFeatureCode['SUS_MOBI_LINE']
  },
  [UNSUSPEND_LINE]: {
    pageTitle: 'Un-Suspend Line',
    defaultTerm: '24',
    transactionType: UNSUSPEND_LINE,
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    steps: [
      { pageName: 'UNSUSPEND_LINE_STEP_DESC', pageKey: 'unsuspendline' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    suspendLineEndDateMaxLimit: 365,
    userPermissionKey: userPolicyFeatureCode['UNSUS_MOBI_LINE']
  },
  [CATALOGUE]: {
    pageTitle: 'Catalogue',
    defaultTerm: '24',
    bulk: {},
    priceKey: 'reconPrice',
    transactionType: CATALOGUE,
    userPermissionKey: userPolicyFeatureCode['VIEW_CATALOGUE']
  },
  [CEASE_ADDONS]: {
    pageTitle: 'Cease Add-ons',
    transactionType: CEASE_ADDONS,
    steps: [
      { pageName: 'CEASE_ADDONS_PAGE_STEP_DESC_1', pageKey: 'ceaseaddonsmobile' },
      { pageName: 'CEASE_ADDONS_PAGE_STEP_DESC_2', pageKey: 'selectceaseaddons' },
      { pageName: 'CEASE_ADDONS_PAGE_STEP_DESC_3', pageKey: 'revieworder' }
    ],
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    penalty: APP_ENV_CONFIG['penalty'],
    userPermissionKey: userPolicyFeatureCode['CEASE_MOBI_ADDON']
  },
  [ACTIVATE_SIM]: {
    pageTitle: 'Activate Sim',
    transactionType: ACTIVATE_SIM,
    userPermissionKey: userPolicyFeatureCode['SIM_ACT_REQUEST']
  },
  [CHECK_ELIGIBILITY]: {
    pageTitle: 'Check Eligibility',
    defaultTerm: '24',
    priceKey: 'checkeligibilityprice',
    transactionType: CHECK_ELIGIBILITY,
    steps: [{ pageName: 'TITLE_CHECK_ELIGIBILITY', pageKey: 'EligibleNumbersDetails' }],
    userPermissionKey: userPolicyFeatureCode['USER_PLANS']
  },
  [ELIGIBLIE_NUMBERS_DETAILS]: {
    pageTitle: 'Eligible Numbers Details',
    defaultTerm: '24',
    priceKey: 'eligiblenumbersdetailsprice',
    transactionType: ELIGIBLIE_NUMBERS_DETAILS,
    penalty: APP_ENV_CONFIG['penalty']
  },
  [RESERVE_NUMBER]: {
    pageTitle: 'Reserve Numbers',
    transactionType: RESERVE_NUMBER,
    userPermissionKey: userPolicyFeatureCode['RESERVE_NUMBER']
  },
  [TERMINATE_NUMBER]: {
    pageTitle: 'Terminate Number',
    defaultTerm: '24',
    transactionType: TERMINATE_NUMBER,
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    steps: [
      { pageName: 'CONTRACT_PAGE_STEP_DESC', pageKey: 'terminatenumber' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    userPermissionKey: userPolicyFeatureCode['TER_MOB_LINE']
  },
  [REPLACE_SIM]: {
    pageTitle: 'Replace SIM Card',
    defaultTerm: '24',
    transactionType: REPLACE_SIM,
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    steps: [
      { pageName: 'CONTRACT_PAGE_STEP_DESC', pageKey: 'replacesim' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    simtypes: ['3-in-1 SIM', '5G SIM', 'eSIM'],
    userPermissionKey: userPolicyFeatureCode['REP_SIM_CARD']
  },
  [REPORT_LOST]: {
    pageTitle: 'Report Lost',
    defaultTerm: '24',
    transactionType: REPORT_LOST,
    steps: [
      { pageName: 'REPORT_LOST_MOBILE_NUMBER_STEP1', pageKey: 'reportlost' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    bulk: {
      min: APP_ENV_CONFIG['bulk-min'],
      max: APP_ENV_CONFIG['bulk-max']
    },
    preSelectThreshold: APP_ENV_CONFIG['pre-select-threshold'],
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    addonLimit: APP_ENV_CONFIG['add-on-limit'],
    processingFee: APP_ENV_CONFIG['processing-fee'],
    userPermissionKey: userPolicyFeatureCode['REPORT_LOST_MOBI']
  },
  [NUMBER_PORT]: {
    pageTitle: 'Port-in Number',
    defaultTerm: '24',
    priceKey: 'numberPort',
    transactionType: NUMBER_PORT,
    steps: [
      { pageName: 'PARTICULARS_OF_THE_SUBSCRIBER', pageKey: 'numberPort' },
      { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
      { pageName: 'EQUIPMENT_PAGE_STEP_DESC', pageKey: 'equipment' },
      { pageName: 'ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    bulk: {
      min: APP_ENV_CONFIG['bulk-min'],
      max: APP_ENV_CONFIG['bulk-max']
    },
    preSelectThreshold: APP_ENV_CONFIG['pre-select-threshold'],
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    addonLimit: APP_ENV_CONFIG['add-on-limit'],
    simCardTypes: [
      {
        name: '3-in-1 SIM',
        type: '3IN1SIM',
        networkType: '3G'
      },
      {
        name: '5G SIM',
        type: '5GSIM',
        networkType: '5G'
      }
    ],
    userPermissionKey: userPolicyFeatureCode['BUY_PORT_IN']
  },
  [TRANSFER_MOBILE_LINE]: {
    pageTitle: 'Transfer Mobile Lines',
    defaultTerm: '24',
    transactionType: TRANSFER_MOBILE_LINE,
    steps: [
      { pageName: 'TRANSFER_MOBILE_LINE_STEP1', pageKey: 'transfermobileline' },
      { pageName: 'TRANSFER_MOBILE_LINE_STEP2', pageKey: 'Transferdetailapplication' },
      { pageName: 'TRANSFER_MOBILE_LINE_STEP3', pageKey: 'transferlineservicedocuments' },
      { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
      { pageName: 'SELECT_ADDONS_PAGE_STEP_DESC', pageKey: 'transferlineaddon' }
    ],
    userPermissionKey: userPolicyFeatureCode['TRAN_MOBI_LINE']
  },
  [CHANGE_MOBILE_NUMBER]: {
    pageTitle: 'Change Mobile Number',
    defaultTerm: '24',
    transactionType: CHANGE_MOBILE_NUMBER,
    steps: [
      { pageName: 'REPORT_LOST_MOBILE_NUMBER_STEP1', pageKey: 'changeMobileNumber' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    bulk: {
      min: APP_ENV_CONFIG['bulk-min'],
      max: APP_ENV_CONFIG['bulk-max']
    },
    preSelectThreshold: APP_ENV_CONFIG['pre-select-threshold'],
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    addonLimit: APP_ENV_CONFIG['add-on-limit'],
    processingFee: APP_ENV_CONFIG['processing-fee'],
    userPermissionKey: userPolicyFeatureCode['CHANGE_MOBI_NUM']
  },
  [CU]: {
    pageTitle: 'Change User'
  },
  [CHANGE_BILLING_ADDRESS]: {
    pageTitle: 'Change Billing Address'
  },
  simCardTypes: [
    {
      name: '3-in-1 SIM',
      type: '3IN1SIM',
      networkType: '3G'
    },
    {
      name: '5G SIM',
      type: '5GSIM',
      networkType: '5G'
    }
  ],
  billingAccountOptions: [
    {
      label: 'Single billing account',
      value: 'single',
      info: 'Create a new billing account for all numbers in the order'
    },
    {
      label: 'Multiple billing accounts',
      value: 'multiple',
      info: 'Create a new billing account for each number in the order'
    }
  ],
  planFeatures: [
    {
      key: 'localData',
      value: '',
      context: 'Data'
    },
    {
      key: 'localSms',
      value: '',
      context: 'Local SMS/MMS'
    },
    {
      key: 'localMin',
      value: '',
      context: 'Outgoing Calls'
    }
  ],
  deliveryAddress: {
    maximum: 15
  },
  [USER_GUIDE]: {
    pageTitle: 'User Guide',
    transactionType: USER_GUIDE,
  },
  [SER_ROADSHOW]: {
    pageTitle: 'SER Roadshow',
    defaultTerm: '24',
    transactionType: SER_ROADSHOW,
    steps: [
      { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
      { pageName: 'EQUIPMENT_PAGE_STEP_DESC', pageKey: 'equipment' },
      { pageName: 'ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    bulk: {
      min: APP_ENV_CONFIG['bulk-min'],
      max: APP_ENV_CONFIG['bulk-max']
    },
    preSelectThreshold: APP_ENV_CONFIG['pre-select-threshold'],
    gstPercent: APP_ENV_CONFIG['gst-percent'],
    addonLimit: APP_ENV_CONFIG['add-on-limit']
  },
  [REFIT_LINE]: {
    pageTitle: 'Refit Line',
    transactionType: REFIT_LINE,
    steps: [
      { pageName: 'CONTRACT_PAGE_STEP_DESC', pageKey: 'refitline' },
      { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
    ],
    userPermissionKey: userPolicyFeatureCode['REFIT_MOBI_LINE']
  },
  [BUY_E_FORM]: {
    pageTitle: 'eForm',
    transactionType: BUY_E_FORM,
    userPermissionKey: userPolicyFeatureCode['BUY_E_FORM']
  },
  selectNumberLimit: 20,
  terminateDateMaxLimit: 29,
  suspendDateMaxLimit: 12,
  gstPercent: APP_ENV_CONFIG['gst-percent'],
  EQPTPENALTY: "EQPTPENALTY",
  VASPENALTY: "VASPENALTY",
  DWNGRADEPENALTY: "DWNGRADEPENALTY",
  noOfDaysForAutoSimActivation: 7,
  maxThresholdStockCount: 10,
  minThresholdStockCount: 0,
  SIMOnly: 'SIMOnly',
  MOBILESHARE_PLAN: 'MobileShare Supplementary Plan',
  MOBILESHARE_PLAN_TYPE: 'Mobileshare',
  NUMBER_SHARE_BILLING_DURATION: "24 hours",
  NUMBER_SHARE_PLAN: "Combo, XO, SIM only or MobileShare supplementary plan",
  NUMBER_SHARE_DEVICES: "iPhone (iPhone 6 or newer, running on iOS11.2.5 or later), and an Apple Watch",
  displayNumberLimit: 10,
  numberSelectionTooltipLimit: 1,
  SER_ROADSHOW_HYBRID_ENABLED: false,
  NUMBER_POOLING_PLAN: 'Enterprise Mobile Pooling',
  EARLY_RECONTRACT: 'EARLY_RECONTRACT',
  STEPS: [
    { pageName: 'CONTRACT_PAGE_STEP_DESC', pageKey: 'contract' },
    { pageName: 'PRICEPLAN_PAGE_STEP_DESC', pageKey: 'priceplan' },
    { pageName: 'EQUIPMENT_PAGE_STEP_DESC', pageKey: 'equipment' },
    { pageName: 'ADDONS_PAGE_STEP_DESC', pageKey: 'addon' },
    { pageName: 'CARTS_REVIEW_PAGE_STEP_DESC', pageKey: 'revieworder' }
  ]
};

export const smartTemplateCategories = [
  { text: 'All', value: '', pathUrl: '', endUserPath: '' },
  { text: APP_CONFIG.NEWLINE?.['pageTitle'], value: NEWLINE, pathUrl: 'ORDER_PRICEPLAN', endUserPath: 'ORDER_REVIEW' },
  { text: APP_CONFIG.RECONTRACT?.['pageTitle'], value: RECONTRACT, pathUrl: 'ORDER_PRICEPLAN', endUserPath: 'ORDER_CONTRACT' },
  { text: APP_CONFIG.BUY_ADD_ONS?.['pageTitle'], value: BUY_ADD_ONS, pathUrl: 'ORDER_ADDONS', endUserPath: 'BUY_ADD_ONS' },
  { text: APP_CONFIG.RRP_EQUIPMENT?.['pageTitle'], value: RRP_EQUIPMENT, pathUrl: 'ORDER_EQUIPMENT', endUserPath: 'ORDER_REVIEW' },
  { text: APP_CONFIG.RRP_ACCESSORY?.['pageTitle'], value: RRP_ACCESSORY, pathUrl: 'ORDER_EQUIPMENT', endUserPath: 'ORDER_REVIEW' }
]